import type { LoanUserResponse } from '~/types/api';
import type { LoanFiltersType } from '~/types/loans';
import httpRequest from '~/utils/httpRequest';

export const getPartnerLoans = async (
    fiters: LoanFiltersType,
): Promise<LoanUserResponse> => {
    const res = await httpRequest.get<LoanUserResponse>('/api/getLoanUsers', {
        params: fiters,
    });
    return res.data;
};
